import {
  IDEA_CHANGE_INPUT,
  IDEA_SUBMIT_REQUESTING,
  IDEA_USER_GET_REQUESTING,
  IDEA_USER_SELECT,
  IDEA_USER_MODIFY_REQUESTING,
  IDEA_USER_DELETE_REQUESTING,
  IDEA_SELECTED_CHANGE_INPUT,
  IDEA_FOCUS_MENU,
  IDEA_GET_SELECTION_REQUESTING,
  IDEA_RATE_REQUESTING,
  IDEA_RATE_MODIFY,
  IDEA_GET_ALL_REQUESTING,
  IDEA_SEE_SELECT,
  IDEA_CHANGE_STATUS_REQUESTING,
  IDEA_ALL_ADD_FILTER,
  IDEA_ALL_REMOVE_FILTER,
  IDEA_POST_COMMENT_REQUESTING,
  IDEA_LOAD_ALL_REQUESTING,
  IDEA_UPLOAD_PICTURE_REQUESTING,
  IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING,
  IDEA_GET_REQUESTING,
} from "./constants";

export const uploadIdeaPicture = payload => {
  return {
    type: IDEA_UPLOAD_PICTURE_REQUESTING,
    payload,
  };
};

export const uploadSelectedIdeaPicture = payload => {
  return {
    type: IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING,
    payload,
  };
};

export const changeIdeaInput = payload => {
  return {
    type: IDEA_CHANGE_INPUT,
    payload,
  };
};

export const changeSelectedIdeaInput = payload => {
  return {
    type: IDEA_SELECTED_CHANGE_INPUT,
    payload,
  };
};

export const submitIdeaRequest = payload => {
  return {
    type: IDEA_SUBMIT_REQUESTING,
    payload,
  };
};

export const getUserIdeasRequest = (payload: { userId: string }) => {
  return {
    type: IDEA_USER_GET_REQUESTING,
    payload,
  };
};

export const selectIdea = payload => {
  return {
    type: IDEA_USER_SELECT,
    payload,
  };
};

export const selectSeeIdea = payload => {
  return {
    type: IDEA_SEE_SELECT,
    payload,
  };
};

export const modifyUserIdeaRequest = (payload: {
  userId: string;
  ideaId: string;
  title?: string;
  text?: string;
  status?: string;
}) => {
  return {
    type: IDEA_USER_MODIFY_REQUESTING,
    payload,
  };
};

export const deleteUserIdeaRequest = (payload: {
  userId: string;
  ideaId: string;
  clientId: string;
}) => {
  return {
    type: IDEA_USER_DELETE_REQUESTING,
    payload,
  };
};

export const focusMenu = (payload: number) => {
  return {
    type: IDEA_FOCUS_MENU,
    payload,
  };
};

export const getIdeaSelectionRequest = (payload: { userId: string }) => {
  return {
    type: IDEA_GET_SELECTION_REQUESTING,
    payload,
  };
};

export const rateIdeaRequest = (payload: {
  userId: string;
  ideaId: string;
  rating: number;
}) => {
  return {
    type: IDEA_RATE_REQUESTING,
    payload,
  };
};

export const rateIdeaModify = (payload: number) => {
  return {
    type: IDEA_RATE_MODIFY,
    payload,
  };
};

export const getAllIdeasRequest = (payload: {
  userId: string;
  clientId: string;
  page: number;
}) => {
  return {
    type: IDEA_GET_ALL_REQUESTING,
    payload,
  };
};

export const loadAllIdeasRequest = (payload: {
  userId: string;
  clientId: string;
  page: number;
}) => {
  return {
    type: IDEA_LOAD_ALL_REQUESTING,
    payload,
  };
};

export const modifyIdeaStatusRequest = (payload: {
  userId: string;
  ideaId: string;
  status?: string;
}) => {
  return {
    type: IDEA_CHANGE_STATUS_REQUESTING,
    payload,
  };
};

export const addAllIdeasFilter = (payload: string) => {
  return {
    type: IDEA_ALL_ADD_FILTER,
    payload,
  };
};

export const removeAllIdeasFilter = (payload: string) => {
  return {
    type: IDEA_ALL_REMOVE_FILTER,
    payload,
  };
};

export const commentIdeaRequest = (payload: {
  ideaId: string;
  author: { _id: string; name: string; picture: string };
  text: string;
}) => {
  return {
    type: IDEA_POST_COMMENT_REQUESTING,
    payload,
  };
};

export const getIdeaRequest = (payload: { ideaId: string }) => {
  return {
    type: IDEA_GET_REQUESTING,
    payload,
  };
};
